///Import react section
import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import autoBind from 'auto-bind';
import { withRouter } from "react-router-dom";
import withauthenticatedLayout from '../layouts/withauthenticatedLayout';
import {loadRawMaterialNonConformityFromBackEnd} from '../../store/rawMaterialNonConformity/RawMaterialActions';
import { connect } from 'react-redux';
import {cancelWorflowQualityFromBackend} from '../../store/workflows/workflowActions';
import CancelWorkflow from '../common/CancelWorkflow';

class CancelContainer extends Component {
  constructor (props) {
    super(props);
    autoBind(this);
    this.state = {

    }
  }

    /**
    * componentDidMount
    */
   componentDidMount() {
    let rawMaterialToken = this.props.match.params.token;
    this.props.loadRawMaterialNonConformity(rawMaterialToken);
}

      /**
     * Cancel a quality Failure from back end
     */
    onCancelWorkflowsDocument(cancelComment, razonForCancel){
      let token =this.props.match.params.token;
      this.props.cancelWorflowQualityFromBackend(token, cancelComment, razonForCancel)
      .then(() =>{
        this.props.history.push(`/rawmaterialnonconformity/${this.props.rawMaterial.token}`)
      }).catch(() =>{
          this.setState({
              showToaster: true,
              toasterMessage: <Translate id="common.errorToSave" />,
              toasterVariant: "error",
          })
      })
  }

  render () {
    return (
      <CancelWorkflow
        {...this.props}
          workflow= {this.props.qualityFailure}
          onCancelWorkflowsDocument={this.onCancelWorkflowsDocument}
          isSaving={this.props.isCancel}
          link = {'rawmaterialnonconformity'}
      />
    )
  }
}

/**
 *  Defines the properties injecteded from the store to view container
 *
 * @param {*} state
 * @returns
 */
function mapStateToProps(state) {
    let rawMaterial = state.rawMaterialNonConformity.get("rawMaterial");
   return {
      isCancel: state.workflow.get('isCancel'),
      rawMaterial: rawMaterial ? rawMaterial.toJS() : null,
  }
}

/**
 * Defines the actions injectes to the component
 *
 * @param {*} state
 * @returnss
 */
const mapDispatchToProps = dispatch => {
  return {
    loadRawMaterialNonConformity: (token) => {
        return dispatch(loadRawMaterialNonConformityFromBackEnd(token));
    },
    cancelWorflowQualityFromBackend: (token, cancelComment, razonForCancel) => {
        return dispatch(cancelWorflowQualityFromBackend(token, cancelComment, razonForCancel));
    },
    
  }
}

export default withauthenticatedLayout((withRouter) (connect(mapStateToProps, mapDispatchToProps)(CancelContainer)));